"use client";

import { c as _c } from "react/compiler-runtime";
import { useServerConfiguration } from "@/contexts/server-configuration/server-configuration.context";
import { useSite } from "@/contexts/site/site.context";
import type { DomId } from "@/vendors/GoogleTag/config/ad-slots.config";
import { useSetupAds } from "@/vendors/GoogleTag/hooks/use-setup-ads.hook";
type SetupPageAdSlotsProps = {
  readonly domIds: ReadonlyArray<DomId>;
};

/**
 * A small client component for setting up a page's ad slots.
 */
export function SetupPageAdSlots(t0) {
  const $ = _c(3);
  const {
    domIds
  } = t0;
  const {
    adUnitDomain
  } = useServerConfiguration();
  const {
    domain: currentSiteDomain
  } = useSite();
  const domain = adUnitDomain ?? currentSiteDomain;
  let t1;
  if ($[0] !== domIds || $[1] !== domain) {
    t1 = {
      domain,
      domIds
    };
    $[0] = domIds;
    $[1] = domain;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useSetupAds(t1);
  return null;
}